'use strict';

angular.module('mediacloudApp')
    .factory('Register', function ($resource) {
        return $resource('api/register', {}, {
        });
    });


